import axios from 'axios';
import logComponent from '../logComponent';

const ContactUs = (function() {

  function Submit(contactUs) {
    if (logComponent('ContactUsAPI')) { console.debug('ContactUsAPI Submit'); }

    return axios.post('api/ContactUs/Submit', contactUs);
  }


  return {
    Submit
  }
})();

export default ContactUs;